import { render, staticRenderFns } from "./EdTable.vue?vue&type=template&id=613cfd4c&"
import script from "./EdTable.vue?vue&type=script&lang=js&"
export * from "./EdTable.vue?vue&type=script&lang=js&"
import style0 from "./EdTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports